import { render, staticRenderFns } from "./form-card.vue?vue&type=template&id=f1e8b1f6&"
import script from "./form-card.vue?vue&type=script&lang=js&"
export * from "./form-card.vue?vue&type=script&lang=js&"
import style0 from "./form-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports